export const fieldWrapperWithChangesTranslations = {
  tipContent: 'fieldwrapperwithchanges-tip_content',
}
